@if (loading) {
  <mat-progress-bar mode="buffer" class="dialog-progress"></mat-progress-bar>
}

<div class="standard-dialog">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ (data.mode === 'create' ? 'Courses.Overview.AddLecture' : 'Global.EditLecture') | translate }}</h2>
      <p class="subtitle">{{ (data.mode === 'create' ? 'Courses.Overview.AddLectureDesc' : 'Global.UpdateDetails') | translate }}</p>
    </div>
    <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <mat-dialog-content class="form-content">
    <div class="w-100">
      <mat-label class="form-label">{{ 'Global.Name' | translate }}</mat-label>
      <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
        <input matInput [disabled]="loading" [(ngModel)]="lectureName" (keyup.enter)="onSubmit()" [placeholder]="'Courses.EnterLectureTitle' | translate" />
      </mat-form-field>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions class="footer">
    <div class="left-actions"></div>
    <div class="right-actions">
      <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
      <button mat-flat-button color="primary" [disabled]="buttonLock || loading" (click)="onSubmit()">
        {{ (data.mode === 'create' ? 'Global.Create' : 'Global.Save') | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
